import { format } from 'date-fns';
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Image, Navbar, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { BiLeftArrowAlt } from "react-icons/bi";
import { HiArrowLeft } from 'react-icons/hi';
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import stempelIcon from '../../icons/stempel.png';
import ttdIcon from '../../icons/ttd.png';
import Header from "../../Layout/Header";
import SidebarMenu from "../../Layout/SidebarMenu";
import BrandLogo from '../../logo.png';
import { useAppConfig } from '../../Utils/AppConfigContext';
import { getEndpointUrl, numberToRomawi } from "../../Utils/Common";
import Error404 from '../Error404';

const CetakOffer = ({ item }) => {
    const componentRef = useRef();

    const { config, loading, error, getSignatureName, getSignatureRole, getLogoUrl, getSignatureStampUrl, getSignatureUrl, getOfferTnc } = useAppConfig();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [error404, setError404] = useState(false);

    const [isLoading, setLoading] = useState(true);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const navigate = useNavigate();

    const params = useParams();

    const [offer, setOffer] = useState([]);

    const fetchDataOffer = useCallback(async (offer_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/offer/${offer_id !== undefined ? offer_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setOffer(json.results);
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchDataOffer(params.offer_id);
    }, [params]);


    return error404 ? <Error404 /> : (
        <>
            <div className="d-block d-sm-none d-print-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Cetak Penawaran</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline d-print-none">
                <Header />
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <Container className="mt-4">
                <Row className="mb d-print-none d-print-none">
                    <Col lg={8} md={9} sm={12} className="offset-md-2">
                        <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3 d-none d-sm-inline"><BiLeftArrowAlt /> Kembali</Button>
                        <ReactToPrint
                            trigger={() => <Button variant="outline-secondary" className="mx-2">Cetak Penawaran</Button>}
                            content={() => componentRef.current}
                        />
                        {/* <Button variant="success">Kirim Penawaran</Button> */}
                    </Col>
                </Row>
                {isLoading ?
                    <Row>
                        <Col className="d-flex justify-content-center mt-5 pt-5 mb-3">
                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                        </Col>
                    </Row> :
                    <Row>
                        <Helmet>
                            <title>PNW-{offer.customerName.toUpperCase()}</title>
                        </Helmet>
                        <Col lg={8} md={9} sm={12} className="offset-md-2 mt-5 fs-13" ref={componentRef}>
                            <Row>
                                <Col>
                                    <Image src={getLogoUrl() || BrandLogo} alt="Brand Logo" fluid className="mb-3" />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <table className="fs-13">
                                        <tr>
                                            <td width={50}>Nomor</td>
                                            <td width={20}>:</td>
                                            <td>{`PN/${numberToRomawi(format(new Date(offer.createdAt), 'MM'))}/${format(new Date(offer.createdAt), 'yy')}/${offer.id}`}</td>
                                        </tr>
                                        <tr>
                                            <td>Prihal</td>
                                            <td width={20}>:</td>
                                            <td className="text-uppercase">Surat Penawaran Harga</td>
                                        </tr>
                                    </table>
                                </Col>
                                <Col>
                                    <div className="d-flex justify-content-end">
                                        <Moment format="DD/MM/YYYY - HH:mm A">{offer.createdAt}</Moment>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <span>Kepada Yth.</span><br /><strong>{offer.customerName.toUpperCase()}</strong><br />
                                    <span>{offer.customerAddress}</span>
                                    <table className="fs-13 mt-3">
                                        <tr>
                                            <td width={100}>No Handphone</td>
                                            <td width={20}>:</td>
                                            <td>{offer.customerPhone}</td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>:</td>
                                            <td>{offer.customerEmail}</td>
                                        </tr>
                                    </table>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <span>Dengan hormat,</span><br /><span>Dengan ini kami sampaikan surat penawaran harga inspeksi mobil, dengan ketentuan sebagaimana dibawah ini :</span>
                                    <table className="table table-bordered fs-13 mt-3">
                                        <tr className="bg-danger text-light">
                                            <th className="px-3">PEKERJAAN / TARGET INSPEKSI</th>
                                            <th className="text-center" width={100}>TOTAL UNIT</th>
                                            <th className="text-center" width={100}>HARGA</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <ol className="fs-13">
                                                    {offer.items?.length > 0 && offer.items.map((item, key) => (
                                                        <li className="pb-2 pt-2" key={`item-${key}`}>
                                                            <span className="fw-bold">{`${item.brandName} - ${item.type}`}</span>, Tahun <span className="fw-bold">{item.builtYear}</span>, <br />Nopol <span className="fw-bold">{item.policeNumber}</span><br /> Lokasi {item.location}
                                                        </li>
                                                    ))}
                                                </ol>
                                                {offer.description}
                                            </td>
                                            <td className="text-center">{`${offer.items?.length} Mobil`}</td>
                                            <td className="text-center">
                                                <NumericFormat
                                                    value={offer.price}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    className="p-0 m-0 bg-transparent"
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value}</span>} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th colSpan={2} style={{ textAlign: 'right' }} className="pe-5">TOTAL :</th>
                                            <th colSpan={3} className="text-center">
                                                <NumericFormat
                                                    value={offer.price}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    className="bg-transparent"
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value}</span>} />
                                            </th>
                                        </tr>
                                    </table>
                                </Col>
                            </Row>
                            <Row className="mt-5 fs-13">
                                <Col>
                                    <p className="px-5 mb-0 pb-0">Hormat Kami,</p>
                                    <div className="stempel">
                                        <Image src={getSignatureStampUrl() || stempelIcon} alt="Stempel Image" className="mx-3" width={250} />
                                    </div>
                                    <Image src={getSignatureUrl() || ttdIcon} alt="TTD Image" className="mx-3 ttd" width={150} />
                                    <p className="px-4">
                                        <span className="text-uppercase fw-medium text-decoration-underline">{getSignatureName()}</span><br />
                                        <span>{getSignatureRole()}</span>
                                    </p>
                                </Col>
                            </Row>
                            <div className="page-break" />
                            <Row className="mt-5 mb-3">
                                <Col>
                                    <Image src={getLogoUrl() || BrandLogo} alt="Brand Logo" fluid />
                                </Col>
                            </Row>
                            <Row className="mt-5">
                                <Col>
                                    <div
                                        className="offer-tnc-content"
                                        dangerouslySetInnerHTML={{ __html: getOfferTnc() }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
            </Container>
        </>
    );
}

export default CetakOffer;
